import { useState, useEffect } from "react";

const googleTranslateLanguageMap = {
    ar: "ar",
    nl: "nl",
    en: "en",
    fr: "fr",
    "fr-CA": "fr",
    de: "de",
    it: "it",
    ja: "ja",
    ko: "ko",
    hu: "hu",
    chi: "zh-CN",
    per: "fa",
    pt: "pt",
    es: "es",
    sv: "sv",
    hin: "hi",
    uk: "uk",
};

export const useGoogleTranslate = (defaultLang = "en") => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if(document.getElementById("google-translate-script")) {
            if(window.google?.translate) setIsLoaded(true);
            return;
        }

        // 1. Define global init callback
        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement(
                {
                    pageLanguage: defaultLang,
                    autoDisplay: false,
                    includedLanguages: "ar,nl,en,fr,de,it,ja,ko,hu,zh-CN,fa,pt,es,sv,hi,uk",
                },
                "google_translate_element"
            );
            setIsLoaded(true);
            document.dispatchEvent(new Event("googleTranslateReady"));
        };

        const script = document.createElement("script");
        script.id = "google-translate-script";
        script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        script.async = true;
        document.body.appendChild(script);
    }, [defaultLang]);

    // Programmatically change language by triggering Google's hidden dropdown
    const changeLanguage = (langKey) => {
        if (!langKey) return;
            const googleLangKey = googleTranslateLanguageMap[langKey] || langKey;

        const hostname = window.location.hostname;
        if (langKey === "en") {
            const cookieDomains = [
                "",
                hostname,
                `.${hostname}`,
                ".jobma.com",
            ];

            cookieDomains.forEach((domain) => {
                const domainPart = domain ? `; domain=${domain}` : "";

                document.cookie =
                    `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0; path=/${domainPart}`;
            });

            window.location.reload();
            return;
        }
        const cookieValue = `/en/${googleLangKey}`;

        document.cookie = `googtrans=${cookieValue}; path=/`;
        document.cookie = `googtrans=${cookieValue}; path=/; domain=${hostname}`;

        const select = document.querySelector(".goog-te-combo");

        if (select) {
            select.value = googleLangKey;
            select.dispatchEvent(new Event("change"));
        } else {
            window.location.reload();
        }
    };

    return { isLoaded, changeLanguage };
};

// Language mapping adjusted for Google Translate language keys (e.g. 'zh-CN' for Chinese, 'hi' for Hindi)
export const languages = [
    {
        key: "ar",
        label: "عربي",
        voice_label: "Arabic",
        image: "/interview/first-theme/images/svg/flags/arabic.svg",
    },
    {
        key: "nl",
        label: "Nederlands",
        voice_label: "Dutch",
        image: "/interview/first-theme/images/svg/flags/dutch.svg",
    },
    {
        key: "en",
        label: "English",
        voice_label: "English",
        image: "/interview/first-theme/images/svg/flags/english.svg",
    },
    {
        key: "fr",
        label: "Français",
        voice_label: "French",
        image: "/interview/first-theme/images/svg/flags/french.svg",
    },
    {
        key: "fr-CA",
        label: "Français (Canada)",
        voice_label: "French Canada",
        image: "/interview/first-theme/images/svg/flags/canada.svg",
    },
    {
        key: "de",
        label: "Deutsch",
        voice_label: "German",
        image: "/interview/first-theme/images/svg/flags/german.svg",
    },
    {
        key: "it",
        label: "Italiana",
        voice_label: "Italian",
        image: "/interview/first-theme/images/svg/flags/italian.svg",
    },
    {
        key: "ja",
        label: "日本語",
        voice_label: "Japanese",
        image: "/interview/first-theme/images/svg/flags/japanese.svg",
    },
    {
        key: "ko",
        label: "한국인",
        voice_label: "Korean",
        image: "/interview/first-theme/images/svg/flags/korean.svg",
    },
    {
        key: "hu",
        label: "Magyar",
        voice_label: "Magyar",
        image: "/interview/first-theme/images/svg/flags/hungarian.svg",
    },
    {
        key: "zh-CN",
        label: "普通话",
        voice_label: "Mandarin",
        image: "/interview/first-theme/images/svg/flags/mandarin.svg",
    },
    {
        key: "fa",
        label: "فارسی",
        voice_label: "Persian",
        image: "/interview/first-theme/images/svg/flags/persian.svg",
    },
    {
        key: "pt",
        label: "Português",
        voice_label: "Portuguese",
        image: "/interview/first-theme/images/svg/flags/portuguese.svg",
    },
    {
        key: "es",
        label: "Español",
        voice_label: "Spanish",
        image: "/interview/first-theme/images/svg/flags/spanish.svg",
    },
    {
        key: "sv",
        label: "svenska",
        voice_label: "Swedish",
        image: "/interview/first-theme/images/svg/flags/swedish.svg",
    },
    {
        key: "hi",
        label: "Hindi",
        voice_label: "Hindi",
        image: "/interview/first-theme/images/svg/flags/hindi.svg",
    },
    {
        key: "uk",
        label: "українська",
        voice_label: "Ukrainian",
        image: "/interview/first-theme/images/svg/flags/ukrainian.svg",
    },
];

